import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

async function getDocuments(token, type) {
  const url = `${process.env.REACT_APP_API_URL}/Document?type=${type}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch document');
    throw error;
  }
}

async function uploadDocument(token, fileName, title, type, file) {
  const url = `${process.env.REACT_APP_API_URL}/Document/uploadDocument`;
  const formData = new FormData();
  formData.append('fileName', fileName);
  formData.append('title', title);
  formData.append('type', type);
  formData.append('file', file); 

  try {
    const response = await axios.post(url, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('There was an error uploading the file!');
    throw error;
  }
}

export default { getDocuments, uploadDocument };
